<script setup lang="ts"></script>

<template>
  <icon name="mdi:google-classroom" />
</template>

<style scoped></style>
